import classNames from 'classnames'
import React from 'react'

import styles from './EditButton.css'

import IconButton from 'src/components/common/IconButton/IconButton'

type Props = {
  className?: string
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  disabled?: boolean
  title?: string
  iconClassName?: string
}
export function EditButton({className, ...otherProps}: Props) {
  return (
    <IconButton
      className={classNames(styles.editButton, className)}
      title={'Edit'}
      aria-label={'Edit'}
      {...otherProps}
      icon={'pencil'}
    />
  )
}
